import { render } from "./InputRadioNewTheme.vue?vue&type=template&id=d741ffde"
import script from "./InputRadioNewTheme.vue?vue&type=script&lang=js"
export * from "./InputRadioNewTheme.vue?vue&type=script&lang=js"

import "./InputRadioNewTheme.vue?vue&type=style&index=0&id=d741ffde&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__